/*
 * File: huddle-dashboard.service.ts
 * Project: a-a
 * File Created: Monday, 1st December 2025 10:19:24 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 1st December 2025 10:42:50 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { ActivityQueryParams, TaskQueryParams } from '../model/dashboard.model';

import { ApiConstants } from './api-constants';
import { HuddleApiConstants } from './huddle-api-constants';
export class HuddleDashboardService {
  static getHuddleDeal = async () => {
    return await (
      await axios.get(HuddleApiConstants.DASHBOARD_API.GET_DEAL.URL())
    ).data;
  };
  static getHuddleTasks = async (query: TaskQueryParams) => {
    return await (
      await axios.get(
        HuddleApiConstants.DASHBOARD_API.GET_TASKS.URL() +
          HuddleApiConstants.DASHBOARD_API.GET_TASKS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getHuddleActivity = async (query: ActivityQueryParams) => {
    // console.log(HuddleApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(
        HuddleApiConstants.DASHBOARD_API.GET_ACTIVITY.URL() +
          HuddleApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getHuddleClient = async () => {
    // console.log(HuddleApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(HuddleApiConstants.DASHBOARD_API.GET_CLIENT.URL())
    ).data;
  };
  static getHuddleActionAccount = async () => {
    // console.log(HuddleApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(HuddleApiConstants.DASHBOARD_API.GET_ACTION_ACCOUNT.URL())
    ).data;
  };
  static createHuddleTasks = async (data: any) => {
    return await (
      await axios.post(HuddleApiConstants.DASHBOARD_API.HUDDLE_TASK.URL(), data)
    ).data;
  };
  static editHuddleTask = async (id: string, data: any) => {
    return await (
      await axios.patch(HuddleApiConstants.DASHBOARD_API.EDIT_HUDDLE_TASK.URL(id), data)
    ).data;
  };
  static deleteHuddleTask = async (id: string) => {
    return await (
      await axios.delete(HuddleApiConstants.DASHBOARD_API.DELETE_HUDDLE_TASK.URL(id))
    ).data;
  };
  static getHuddleOptions = async (email: string) => {
    return await (
      await axios.get(HuddleApiConstants.DASHBOARD_API.GET_DROPDOWN.URL(email))
    ).data;
  };
}
